import React from 'react';
import { Link } from 'react-router-dom';
import scrollToElement from 'scroll-to-element';
import Carousel from '@brainhubeu/react-carousel';

import AudienceSegmentModal from 'components/shared/landing/audience-segment-modal';
import FormContact from 'components/form-contact';
import styles from './styles.module.scss';

import lessonIcon from 'assets/img/landing/landing-icon-lesson.svg';
import SELSkillsMockup from 'assets/img/Mockup-SEL-Skills.png';
import GetOptimalDiscourse from 'components/containers/funnel/images/Get-Optimal-Discourse.png';
import TeamCelebrationPoster from 'assets/img/landing-team-celebration-poster.png';
import NursesPoster from 'assets/img/team21.jpg';
import EducatorPoster from 'assets/img/benefits-of-sel.jpg';
import ParentPoster from 'assets/img/sel-pages/parents-impact.jpg';

import '@brainhubeu/react-carousel/lib/style.css';

export default class Landing extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      audienceSegmentModalOpen: false,
      redirectToEducator: false,
      redirectToParent: false,
    };

    this.onClickAudienceSegmentModal =
      this.onClickAudienceSegmentModal.bind(this);
    this.onCloseAudienceSegmentModal =
      this.onCloseAudienceSegmentModal.bind(this);
    this.onContact = this.onContact.bind(this);
  }

  componentDidMount() {
    setTimeout(() => {
      this.forceUpdate();
    }, 2000);
  }

  onClickAudienceSegmentModal() {
    this.setState({ audienceSegmentModalOpen: true });
  }

  onCloseAudienceSegmentModal() {
    this.setState({ audienceSegmentModalOpen: false });
  }

  onContact() {
    this.setState({ audienceSegmentModalOpen: false }, () =>
      scrollToElement('#contact'),
    );
  }

  scrollToContact = () => {
    const contactContainer = document.getElementById('contact-container');

    if (contactContainer) {
      contactContainer.scrollIntoView();
    } else {
      setTimeout(this.scrollToContact, 300);
    }
  };

  update = () => {
    this.forceUpdate();
  };

  render() {
    const { audienceSegmentModalOpen } = this.state;
    return (
      <div className="w-100">
        <section className="landing-header">
          <div className="landing-carousel-container">
            <Carousel autoPlay={5000} infinite dots>
              <img
                className="landing-image"
                src={TeamCelebrationPoster}
                alt="real students celebrating their accomplishements on Unyted"
              />
              <img
                className="landing-image"
                src={NursesPoster}
                alt="a team of nurses and doctors posing looking confident and ready to learn"
              />
              <img
                className="landing-image"
                src={EducatorPoster}
                alt="a teacher assists a student in a classroom where each student has a computer"
              />
              <img
                className="landing-image"
                src={ParentPoster}
                alt="a parent and child at a study desk, reviewing data on a mobile device"
              />
            </Carousel>
          </div>
          <div className="dark-overlay" />
          <div className="container h-100 overlay-container">
            <div className="row h-100">
              <div className="col col-lg-8 offset-lg-2 col-md-10 offset-md-1 d-flex justify-content-center">
                <div className="text-container">
                  <h1>We help you develop problem solvers.</h1>
                  <p>
                    Our online platform is used by Parents, Schools, and
                    Corporate Educators for education and skill development that
                    meaningfully connects learners to unlock “whole” potential.
                  </p>
                  <button
                    onClick={this.onClickAudienceSegmentModal}
                    className="success"
                  >
                    Find Your Role
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className={styles.relationshipDriven}>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-12 col-lg-6">
                <img src={lessonIcon} alt="" />
              </div>
              <div className={`col-12 col-lg-6 ${styles.textContainer}`}>
                <h5>STEP 1: IDENTIFY YOUR ROLE</h5>
                <h2>Empowering learners through the people who support them</h2>
                <p>
                  Whether you're a parent, educator or talent developer, Unyted
                  is designed to provide you options on how to support the
                  growth of the learners in your lives.
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className={styles.realWorldConnection}>
          <div className="container">
            <div className="row align-items-center">
              <div
                className={`col-12 col-lg-6 order-lg-1 order-2 ${styles.textContainer}`}
              >
                <h5>STEP 2: RELATIONSHIP-DRIVEN LEARNING</h5>
                <h2>The TEAM Method</h2>
                <p>
                  {' '}
                  Our{' '}
                  <Link target="_blank" to="/the-team-method">
                    patent-pending online TEAM Method&trade;
                  </Link>{' '}
                  is used by educators and learners in-person, fully online, or
                  a combination (hybrid). It's used by teachers in schools and
                  talent developers in large corporations. Parents who seek
                  support from elite educators outside of school in{' '}
                  <Link target="_blank" to="/unyted-learning-centers">
                    Unyted Learning Centers
                  </Link>{' '}
                  will find certified educators who guide learners through group
                  problem solving that matches learning to how the real world
                  works.{' '}
                </p>
                <button onClick={this.onClickAudienceSegmentModal}>
                  Join the movement
                </button>
              </div>
              <div className="col-12 col-lg-6 order-lg-2 order-1">
                <img src={GetOptimalDiscourse} alt="" />
              </div>
            </div>
          </div>
        </section>
        <section className={styles.relationshipDriven}>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-12 col-lg-6">
                <img src={SELSkillsMockup} alt="" />
              </div>
              <div className={`col-12 col-lg-6 ${styles.textContainer}`}>
                <h5>STEP 3: CONNECT TO REAL WORLD</h5>
                <h2>Personalized skills feedback gets results</h2>
                <p>
                  Unyted educators use{' '}
                  <Link target="_blank" to="/sel-encyclopedia">
                    key Power Skills
                  </Link>{' '}
                  to help learners perform better in a classroom setting and
                  also show learners how to transfer those skills to success in
                  real world scenarios. No compromise.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section id="contact">
          <div className="container">
            <div className="row">
              <div className="col">
                <FormContact
                  showHeader
                  showSubtext
                  messageLabel="How can Unyted help you?"
                />
              </div>
            </div>
          </div>
        </section>
        {audienceSegmentModalOpen && (
          <AudienceSegmentModal
            onClose={this.onCloseAudienceSegmentModal}
            onSelectEducatorInfoURL="/educators"
            onSelectEducatorSolutionsURL="/online-platform"
            onSelectParentInfoURL="/parents"
            onSelectParentSolutionsURL="/marketplace"
            onContact={this.onContact}
          />
        )}
      </div>
    );
  }
}
